(function () {
  'use strict';

  var emblaPromise = null;

  function loadScript(src) {
    if (!src) return Promise.reject(new Error('missing script src'));
    if (window.EmblaCarousel) return Promise.resolve(window.EmblaCarousel);
    if (emblaPromise) return emblaPromise;
    emblaPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        existing.addEventListener('load', function () { resolve(window.EmblaCarousel); }, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = function () { resolve(window.EmblaCarousel); };
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return emblaPromise;
  }

  function moneyFormatter(root) {
    var currency = root.getAttribute('data-pdp-currency') || 'EUR';
    return function (value) {
      try {
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency }).format(value || 0);
      } catch (error) {
        return '€' + (value || 0).toFixed(2).replace('.', ',');
      }
    };
  }

  function decimalFormatter(value) {
    try {
      return new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value || 0);
    } catch (error) {
      return (value || 0).toFixed(2).replace('.', ',');
    }
  }

  function readVariants(root) {
    var node = root.querySelector('[data-pdp-variants-json]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function pauseInactiveMedia(root, activeIndex) {
    root.querySelectorAll('[data-pdp-slide]').forEach(function (slide) {
      if (parseInt(slide.getAttribute('data-pdp-slide'), 10) === activeIndex) return;
      slide.querySelectorAll('video').forEach(function (video) {
        if (!video.paused) video.pause();
      });
    });
  }

  function setSkeletonDone(slide) {
    if (!slide) return;
    var image = slide.querySelector('img');
    function done() { slide.setAttribute('aria-busy', 'false'); }
    if (!image || (image.complete && image.naturalWidth !== 0)) done();
    else {
      image.addEventListener('load', done, { once: true });
      image.addEventListener('error', done, { once: true });
    }
  }

  function initFallbackGallery(root, thumbs, slides) {
    function activate(index) {
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-pdp-thumb') === String(index));
      });
      slides.forEach(function (slide) {
        var active = slide.getAttribute('data-pdp-slide') === String(index);
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        if (active) setSkeletonDone(slide);
      });
      pauseInactiveMedia(root, index);
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activate(parseInt(thumb.getAttribute('data-pdp-thumb'), 10) || 0);
      });
    });
    return { activate: activate };
  }

  function initGallery(root) {
    var viewport = root.querySelector('[data-pdp-gallery-main]');
    var track = root.querySelector('[data-pdp-gallery-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-slide]'));
    if (!viewport || !track || !slides.length) return;

    if (slides.length === 1) {
      setSkeletonDone(slides[0]);
      viewport.classList.add('is-single');
      initLightbox(root);
      return;
    }

    var fallback = initFallbackGallery(root, thumbs, slides);
    var emblaSrc = root.getAttribute('data-pdp-embla-src') ||
      (window.GEF_MOTION_VENDOR_URLS && window.GEF_MOTION_VENDOR_URLS.embla);

    loadScript(emblaSrc).then(function (EmblaCarousel) {
      if (typeof EmblaCarousel !== 'function') return;
      slides.forEach(function (slide) { slide.hidden = false; });
      viewport.classList.add('is-embla');
      var embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        loop: false,
        skipSnaps: false
      });

      function sync() {
        var index = embla.selectedScrollSnap();
        thumbs.forEach(function (thumb) {
          var active = thumb.getAttribute('data-pdp-thumb') === String(index);
          thumb.classList.toggle('is-active', active);
          if (active && thumb.scrollIntoView) {
            thumb.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
          }
        });
        slides.forEach(function (slide) {
          var active = slide.getAttribute('data-pdp-slide') === String(index);
          slide.classList.toggle('is-active', active);
          if (active) setSkeletonDone(slide);
        });
        pauseInactiveMedia(root, index);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          embla.scrollTo(parseInt(thumb.getAttribute('data-pdp-thumb'), 10) || 0);
        });
      });
      viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          embla.scrollNext();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          embla.scrollPrev();
        }
      });
      embla.on('select', sync);
      embla.on('reInit', sync);
      sync();
    }).catch(function () {
      fallback.activate(0);
    });

    initLightbox(root);
  }

  function initLightbox(root) {
    var gallery = root.querySelector('[data-pdp-gallery-main]');
    if (!gallery) return;
    gallery.addEventListener('click', function (event) {
      var image = event.target.closest('.gef-cd-pdp__gallery-img');
      if (!image) return;
      event.preventDefault();
      var overlay = document.createElement('div');
      overlay.className = 'gef-cd-pdp-lightbox';
      overlay.innerHTML =
        '<button type="button" class="gef-cd-pdp-lightbox__close" aria-label="Chiudi zoom">×</button>' +
        '<img src="' + image.currentSrc + '" alt="' + (image.getAttribute('alt') || '') + '">';
      document.body.appendChild(overlay);
      document.body.classList.add('gef-cd-lightbox-lock');
      var close = function () {
        overlay.remove();
        document.body.classList.remove('gef-cd-lightbox-lock');
        document.removeEventListener('keydown', onKey);
      };
      var onKey = function (keyEvent) {
        if (keyEvent.key === 'Escape') close();
      };
      overlay.addEventListener('click', function (clickEvent) {
        if (clickEvent.target === overlay || clickEvent.target.closest('.gef-cd-pdp-lightbox__close')) close();
      });
      document.addEventListener('keydown', onKey);
      overlay.querySelector('button').focus();
    });
  }

  function initCopy(root) {
    root.querySelectorAll('[data-pdp-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-pdp-copy');
        if (!navigator.clipboard || !value) return;
        navigator.clipboard.writeText(value).then(function () {
          var label = button.querySelector('[data-pdp-copy-label]');
          if (!label) return;
          var previous = label.textContent;
          label.textContent = 'copiato';
          window.setTimeout(function () { label.textContent = previous; }, 1500);
        });
      });
    });
  }

  function initWishlist(root) {
    var key = 'gef_saved_products';
    function read() {
      try { return JSON.parse(localStorage.getItem(key) || '[]'); }
      catch (error) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(key, JSON.stringify(list.slice(0, 100))); }
      catch (error) {}
    }
    function sync() {
      var list = read();
      root.querySelectorAll('[data-pdp-wishlist]').forEach(function (button) {
        var handle = button.getAttribute('data-product-handle') || root.getAttribute('data-product-handle');
        var active = list.indexOf(handle) !== -1;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.setAttribute('aria-label', active ? 'Rimuovi dai preferiti' : 'Salva nei preferiti');
      });
    }
    root.querySelectorAll('[data-pdp-wishlist]').forEach(function (button) {
      button.addEventListener('click', function () {
        var handle = button.getAttribute('data-product-handle') || root.getAttribute('data-product-handle');
        var list = read();
        var index = list.indexOf(handle);
        if (index !== -1) list.splice(index, 1);
        else list.unshift(handle);
        write(list);
        sync();
      });
    });
    sync();
  }

  function initPurchase(root) {
    var formatMoney = moneyFormatter(root);
    var variants = readVariants(root);
    var form = root.querySelector('#gef-cd-pdp-form');
    var qtyInput = root.querySelector('.gef-cd-pdp__qty-input');
    var unitBox = root.querySelector('[data-pdp-unit-box]');
    var unitOut = unitBox ? unitBox.querySelector('[data-price-per-unit]') : null;
    var totalOut = unitBox ? unitBox.querySelector('[data-total-estimate]') : null;
    var bulkRoot = root.querySelector('[data-gef-cd-bulk]');
    var currentBulkDetail = null;
    var priceMain = root.querySelector('[data-bulk-price]');
    var priceSub = root.querySelector('[data-bulk-sub]');
    var priceCompare = root.querySelector('[data-bulk-compare]');
    var pricePct = root.querySelector('[data-bulk-pct]');
    var variantInput = form ? form.querySelector('[data-pdp-variant-id]') : null;
    var addButton = form ? form.querySelector('[data-pdp-add-button]') : null;
    var addLabel = addButton ? addButton.querySelector('[data-pdp-add-label]') : null;
    var variantStatus = form ? form.querySelector('[data-pdp-variant-status]') : null;
    var stockIndicator = root.querySelector('[data-pdp-stock-indicator]');
    var stockLabel = stockIndicator ? stockIndicator.querySelector('[data-pdp-stock-label]') : null;
    var skuText = root.querySelector('.gef-cd-pdp__code-text');
    var copyButton = root.querySelector('[data-pdp-copy]');
    var vatMultiplier = parseFloat(root.getAttribute('data-pdp-vat-multiplier')) || 1.22;

    function clampQty() {
      if (!qtyInput) return 1;
      var value = parseInt(qtyInput.value, 10) || parseInt(qtyInput.min, 10) || 1;
      var min = parseInt(qtyInput.min, 10) || 1;
      var max = qtyInput.max ? parseInt(qtyInput.max, 10) : null;
      var step = parseInt(qtyInput.step, 10) || 1;
      value = Math.max(value, min);
      if (max) value = Math.min(value, max);
      if (step > 1) value = min + Math.round((value - min) / step) * step;
      qtyInput.value = value;
      return value;
    }

    function findVariantById(id) {
      if (!id) return variants[0] || null;
      return variants.find(function (variant) {
        return String(variant.id) === String(id);
      }) || variants[0] || null;
    }

    function variantText(variant) {
      if (!variant) return '';
      return [
        variant.title,
        Array.isArray(variant.options) ? variant.options.join(' ') : '',
        variant.sku
      ].join(' ').toLowerCase();
    }

    function inferUnitsPerPack(variant) {
      var text = variantText(variant);
      var match = text.match(/(\d{1,5})\s*(?:pz|pzi|pezzi|pcs)\b/i);
      if (match) return Math.max(parseInt(match[1], 10) || 1, 1);
      var sku = variant && variant.sku ? String(variant.sku) : '';
      var skuMatch = sku.match(/[-_\s](\d{1,5})$/);
      if (skuMatch) return Math.max(parseInt(skuMatch[1], 10) || 1, 1);
      return Math.max(parseFloat(unitBox && unitBox.getAttribute('data-units-per-pack')) || 1, 1);
    }

    function setVariantPackUnits(variant) {
      if (!unitBox) return;
      unitBox.setAttribute('data-units-per-pack', String(inferUnitsPerPack(variant)));
    }

    function updateUnitEstimate(detail) {
      if (!unitBox || !unitOut || !totalOut) return;
      if (detail && detail.detail) detail = detail.detail;
      if (!detail || detail.type) detail = currentBulkDetail;
      var units = parseFloat(unitBox.getAttribute('data-units-per-pack')) || 1;
      var quantity = clampQty();
      var unitExcl = detail && typeof detail.unit !== 'undefined' ? parseFloat(detail.unit) : parseFloat(unitBox.getAttribute('data-base-excl')) || 0;
      unitOut.textContent = formatMoney(unitExcl / Math.max(units, 1));
      totalOut.textContent = formatMoney(unitExcl * quantity);
    }

    root.querySelectorAll('[data-qty-dec]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(qtyInput.step, 10) || 1;
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - step;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    root.querySelectorAll('[data-qty-inc]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(qtyInput.step, 10) || 1;
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + step;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', updateUnitEstimate);
    }
    if (bulkRoot) {
      bulkRoot.addEventListener('gef:bulk:change', function (event) {
        currentBulkDetail = event.detail || null;
        updateUnitEstimate(currentBulkDetail);
      });
    }

    root.querySelectorAll('.gef-cd-pdp__chip input[type=radio]').forEach(function (input) {
      input.addEventListener('change', function () {
        var label = input.closest('.gef-cd-pdp__chip');
        var group = input.closest('fieldset');
        if (group) {
          group.querySelectorAll('.gef-cd-pdp__chip').forEach(function (item) {
            item.classList.remove('is-selected');
          });
        }
        if (label && input.checked) label.classList.add('is-selected');
        syncSelectedVariant();
      });
    });

    function selectedOptions() {
      if (!form) return [];
      var fields = form.querySelectorAll('[name^="options["]');
      var values = [];
      fields.forEach(function (field) {
        if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) return;
        values.push(field.value);
      });
      return values;
    }

    function syncCtas(available) {
      if (addButton) {
        addButton.disabled = !available;
        addButton.setAttribute('aria-disabled', available ? 'false' : 'true');
      }
      if (addLabel) addLabel.textContent = available ? 'Aggiungi al carrello' : 'Non disponibile';
    }

    function updatePriceSub(grossPrice) {
      if (!priceSub || !grossPrice) return;
      var inclNode = priceSub.querySelector('[data-bulk-incl]');
      if (inclNode) {
        inclNode.textContent = decimalFormatter(grossPrice);
        return;
      }
      priceSub.textContent = formatMoney(grossPrice) + ' IVA inclusa prima delle condizioni quantità.';
    }

    function updateCompare(compareGross, grossPrice) {
      if (priceCompare) {
        if (compareGross && compareGross > grossPrice) {
          priceCompare.hidden = false;
          priceCompare.textContent = formatMoney(compareGross / vatMultiplier);
        } else {
          priceCompare.hidden = true;
        }
      }
      if (pricePct && (!currentBulkDetail || !currentBulkDetail.discount)) {
        if (compareGross && compareGross > grossPrice) {
          var savedPct = Math.round(((compareGross - grossPrice) * 100) / compareGross);
          pricePct.hidden = false;
          pricePct.textContent = '-' + savedPct + '%';
        } else {
          pricePct.hidden = true;
        }
      }
    }

    function updateSku(match) {
      var nextSku = (match && match.sku) || root.getAttribute('data-product-handle') || '';
      if (!nextSku) return;
      if (skuText) skuText.textContent = 'Codice GEF: ' + nextSku;
      if (copyButton) copyButton.setAttribute('data-pdp-copy', nextSku);
    }

    function syncSelectedVariant() {
      if (!variantInput || !variants.length) return;
      var chosen = selectedOptions();
      if (!chosen.length) return;
      var match = variants.find(function (variant) {
        return variant.options && variant.options.length === chosen.length &&
          variant.options.every(function (option, index) { return option === chosen[index]; });
      });
      if (!match) return;
      variantInput.value = match.id;
      var grossPrice = match.price ? (match.price / 100) : 0;
      var exclPrice = grossPrice ? (grossPrice / vatMultiplier) : 0;
      var compareGross = match.compare_at_price ? (match.compare_at_price / 100) : 0;
      if (priceMain && grossPrice) priceMain.textContent = formatMoney(exclPrice);
      if (match.price) updatePriceSub(grossPrice);
      updateCompare(compareGross, grossPrice);
      updateSku(match);
      if (unitBox && match.price) {
        unitBox.setAttribute('data-base-excl', String(exclPrice));
        setVariantPackUnits(match);
        currentBulkDetail = null;
        updateUnitEstimate();
      }
      syncCtas(match.available);
      if (variantStatus) {
        var qty = parseInt(match.inventory_quantity, 10) || 0;
        var status = 'Disponibilità da confermare';
        if (match.available) {
          if (qty > 0 && qty <= 3) status = qty + ' rimasti per questa variante';
          else if (qty > 0) status = 'Pronta consegna su stock';
          else status = 'Disponibile su conferma logistica';
        } else {
          status = 'Variante non disponibile';
        }
        variantStatus.textContent = status;
        variantStatus.classList.toggle('is-unavailable', !match.available);
      }
      if (stockIndicator && stockLabel) {
        var stockClass = 'supplier';
        var stockText = stockIndicator.getAttribute('data-supplier-label') || 'Disponibile su conferma logistica';
        var stockQty = parseInt(match.inventory_quantity, 10) || 0;
        if (match.available && stockQty > 0) {
          stockClass = 'immediate';
          stockText = stockIndicator.getAttribute('data-immediate-label') || 'Disp. immediata - Spedizione tracciata';
        } else if (!match.available) {
          stockClass = 'unavailable';
          stockText = stockIndicator.getAttribute('data-unavailable-label') || 'Non disponibile';
        }
        stockIndicator.classList.remove(
          'gef-cd-pdp__stock-indicator--immediate',
          'gef-cd-pdp__stock-indicator--supplier',
          'gef-cd-pdp__stock-indicator--unavailable'
        );
        stockIndicator.classList.add('gef-cd-pdp__stock-indicator--' + stockClass);
        stockLabel.textContent = stockText;
      }
      window.dispatchEvent(new CustomEvent('gef:pdp:variant-change', {
        detail: {
          id: match.id,
          available: !!match.available,
          price: match.price,
          compare_at_price: match.compare_at_price,
          title: match.title,
          options: match.options,
          sku: match.sku
        }
      }));
    }

    if (form) {
      form.addEventListener('change', function (event) {
        if (event.target && event.target.name && event.target.name.indexOf('options[') === 0) {
          syncSelectedVariant();
        }
      });
      syncSelectedVariant();
    }
    setVariantPackUnits(findVariantById(variantInput && variantInput.value));
    updateUnitEstimate();
  }

  function init(root) {
    if (!root || root.dataset.gefPdpReady === 'true') return;
    root.dataset.gefPdpReady = 'true';
    initGallery(root);
    initCopy(root);
    initWishlist(root);
    initPurchase(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pdp-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
})();
